module.exports = __webpack_public_path__ + "img/ck-ranking+1.52cf92bf.png";